const FeedbackSkeleton = () => {
  return (
    <div className="space-y-6">
      {/* Stat Cards Skeleton Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-2xl p-4 border border-slate-100/80 shadow-xs flex items-center gap-4"
          >
            <div className="w-10 h-10 rounded-full bg-slate-100 animate-pulse flex-shrink-0" />
            <div className="space-y-2 flex-1">
              <div className="h-3 w-24 bg-slate-100 rounded animate-pulse" />
              <div className="h-6 w-14 bg-slate-200 rounded-lg animate-pulse" />
              <div className="h-2.5 w-28 bg-slate-100 rounded animate-pulse" />
            </div>
          </div>
        ))}
      </div>

      {/* Feedback Review Cards Skeleton Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {[1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="bg-white rounded-2xl border border-slate-100 border-l-4 border-l-slate-200 p-5 shadow-xs flex flex-col justify-between space-y-4"
          >
            <div>
              {/* Header with Avatar and Date */}
              <div className="flex justify-between items-start mb-4">
                <div className="flex items-center gap-3">
                  <div className="w-9 h-9 rounded-full bg-slate-100 animate-pulse flex-shrink-0" />
                  <div className="space-y-1.5">
                    <div className="h-3.5 w-28 bg-slate-200 rounded animate-pulse" />
                    <div className="h-2.5 w-20 bg-slate-100 rounded animate-pulse" />
                  </div>
                </div>
                <div className="h-5 w-20 bg-slate-100 rounded-md animate-pulse" />
              </div>

              {/* Message text skeleton */}
              <div className="space-y-2 mb-4">
                <div className="h-3.5 w-full bg-slate-100 rounded animate-pulse" />
                <div className="h-3.5 w-5/6 bg-slate-100 rounded animate-pulse" />
              </div>
            </div>

            {/* Footer with Booking ID and Action button */}
            <div className="flex items-center justify-between pt-3 border-t border-slate-100">
              <div className="h-3 w-24 bg-slate-100 rounded animate-pulse" />
              <div className="h-7 w-24 bg-slate-100 rounded-xl animate-pulse" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FeedbackSkeleton;
